import SuperTreeSelect from './treeSelect';

export default SuperTreeSelect;
